import { assign, createMachine } from "xstate";
import {
  IChangeSimEsimOrchestrator,
  IMobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { setSimCard } from "@nju/data-access-portal-sim-card";
import { ISimCardFlow } from "../types";

export interface IContext {
  flow: ISimCardFlow;
  iccId: string;
  iccIdError?: string;
  orchestratorId?: string;
}

type IEvent =
  | {
      type: "SET_ICC_ID";
      value: string;
    }
  | {
      type: "ICC_ID_SET_SUCCESS";
      orchestrator: IMobileOrchestrator | IChangeSimEsimOrchestrator;
    }
  | { type: "GENERAL_ERROR" }
  | { type: "SUBMIT" };

export const mobileFullSimCardMachine = createMachine(
  {
    context: {
      iccId: "",
      flow: "ONBOARDING",
    },
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          SET_ICC_ID: {
            actions: "setIccId",
          },
          SUBMIT: {
            target: "validate",
          },
        },
      },
      validate: {
        entry: "validateForm",
        always: [
          {
            cond: "hasNoIccIdErrors",
            target: "setIccId",
          },
          {
            target: "ready",
          },
        ],
      },
      setIccId: {
        invoke: {
          src: "setIccId",
        },
        on: {
          ICC_ID_SET_SUCCESS: {
            actions: "setIccIdSuccess",
            target: "final",
          },
          GENERAL_ERROR: {
            target: "generalError",
          },
        },
      },
      generalError: {
        type: "final",
      },
      final: {
        type: "final",
      },
    },
  },
  {
    services: {
      setIccId: ({ orchestratorId, iccId, flow }) => {
        return async (callback) => {
          if (!orchestratorId) {
            throw new Error("Missing orchestratorId");
          }

          const result = await setSimCard({
            mode: flow === "ONBOARDING" ? "mobile" : "changeSimEsim",
            orchestratorId,
            simOrIccId: iccId,
          });

          if (result.isError) {
            return callback({ type: "GENERAL_ERROR" });
          }

          callback({
            type: "ICC_ID_SET_SUCCESS",
            orchestrator: result.value,
          });
        };
      },
    },
    guards: {
      hasNoIccIdErrors: ({ iccIdError }) => {
        return iccIdError === undefined;
      },
    },
    actions: {
      validateForm: assign<IContext, IEvent>({
        iccIdError: ({ iccId }) => {
          if (iccId.length === 0) {
            return "Wpisz numer swojej karty SIM.";
          }

          if (iccId.length < 19) {
            return "Ten numer jest za krótki. Wpisz 19 cyfr.";
          }

          return;
        },
      }),
      setIccId: assign<IContext, IEvent>((context, event) => {
        if (event.type === "SET_ICC_ID") {
          return {
            iccId: event.value,
          };
        }
        return context;
      }),
    },
  },
);
